// Included before rework
import React, { useEffect, useRef, useState } from "react";
import '../newrelic';
// import "../styles/globals.scss";
import "../styles/productlist.css";
import "../styles/product_page.scss";
// import "bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/slick-slider/slick/slick-theme.css";
import "../node_modules/slick-slider/slick/slick.css";
import "../styles/slick_slider.scss";
import "@/components/BuilderIO/ProductCarousel/ProductCarousel.builder";
import "@/components/BuilderIO/ProductCarousel/NostoProductCarousel.builder";
import "@/components/BuilderIO/ProductCarousel/FeatureCarousel.builder";
import "@/components/BuilderIO/Menu/Menu.builder";
import "@/components/BuilderIO/ContentRow/ContentRow.builder";
import "@/components/BuilderIO/SuperBrands/HeroBanner/HeroBanner.builder";
import "@/components/BuilderIO/Testimonial/Testimonial.builder";
import "@/components/BuilderIO/LogoBanner/LogoBanner.builder";
import "@/components/BuilderIO/Dashhudson/Dashhudson.builder";
import "@/components/BuilderIO/HomePageQuickLinks/HomePageQuickLinks.builder";
import Head from "next/head";

//Included during rework
import "../styles/scss/app.scss";

import { Provider } from "react-redux";
import store from "../redux/store";
import Layout from "../components/layout";
import "swiper/scss";
import { useRouter } from "next/compat/router";
import { isIOS } from "react-device-detect";
import { ErrorBoundary } from "react-error-boundary";
import ErrorComp from "@/components/ErrorsComp";
// import { ErrorBoundary } from '@/components/ErrorBoundary';
import { ErrorReporter } from '@/utils/errorReporting';
// import ErrorComp from "./404";

import { reportError } from "@/helpers/errorHelper";
import { viewOther } from "@/components/common/Nosto";
import { isPWA, isPWAVisits, removePLPFilterCookies } from "@/helpers/generalHelper";
import { generalConstants } from "@/utils/constants";
// import WelcomeLoader from "@/components/PWA/WelcomeLoader";

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const footerRef = useRef(null);
  let routerPath = router.pathname;
  // const [appLoaded, setAppLoaded] = useState(false);
  // const [isComponentLoaded, setIsComponentLoaded] = useState(false);
  // Canonical URL checks if  its a homepage it will references the primary URL else it will append routerpath to the baseURL
  // split("?")= basically clean up the Url Parameter like "?query="
  const canonicalUrl = (`${process.env.NETLIFY_URL}` + (router.asPath === "/" ? "": router.asPath)).split("?")[0];
  /**
   * removes filters from session from given key
   * @param path: String
   */
  function removeLocalFilters(path = '') {
    if(!path) return
    removePLPFilterCookies(path);
  }
  const valinPLPs = ['women','jewelry-watches','beauty','home-gifts','new-arrivals','designer', 'sale', 'search']
  const {pages = []} = router.query
  if (typeof window !== 'undefined') {
    // SUP-3325 added generic code for designer cause association. 
    // make changes in constants file to add any cause for designer
    Object.keys(generalConstants.designer_cause_association).forEach((designer)=>{
      const userCauseFromLocal = JSON.parse(localStorage.getItem("user_cause"));
      let cause;
      if (router.asPath.includes(`/designer/${designer}`)) {
        cause = generalConstants.designer_cause_association[designer];
      } else if (router.asPath.includes(`/${designer}`)) {
        cause = generalConstants.designer_cause_association[designer];
      }
      if(cause) {
        // Check if the URL already has cause param
        // added second conditon to fix SUP-3325 which was caused from the fixes of SUP-3312 and SUP-2930
        if (!router.asPath.includes(`cause=${cause}`) && userCauseFromLocal !== cause) {
          // Check if the URL already has a query parameter
          const querySeparator = router.asPath.includes('?') ? '&' : '?';
          // Redirect to the desired URL with cause param assoicated to designer
          window.location.href = `${process.env.NETLIFY_URL}${router.asPath}${querySeparator}cause=${cause}`;
        }
       }
    })
     
    if (routerPath === "/[...pages]") {
      routerPath = router.query.pages.join('/');
    }
    
    if(pages.length || router.pathname === '/sale' || router.pathname === '/search') {

      if(router.pathname === '/sale') {
        pages.push('sale')
      } 
      if(router.pathname === '/search') {
        pages.push('search')
      }
      let nav = pages[0]
      let isPLP = valinPLPs.includes(nav)
      if(router.asPath === '/designer') {
        isPLP = false
      }
      if(isPLP) {
        let currentPLP = sessionStorage.getItem('currentPLP') || ''
        let previousPLP = sessionStorage.getItem('previousPLP') || ''
        
        if(routerPath !== currentPLP) {
  
          sessionStorage.setItem('currentPLP', routerPath)
          sessionStorage.setItem('previousPLP', currentPLP)
          previousPLP = currentPLP
        }
  
        if(previousPLP) {
  
          removeLocalFilters(sessionStorage.getItem('previousPLP'))
          sessionStorage.removeItem('previousPLP')
        }
      }

    }
 
  }

  const myErrorHandler = (error, info) => {
    // Do something with the error
    // E.g. log to an error logging client here
    var obj = {};
    obj.info = info;
    obj.error = error;
    reportError(obj);

    ErrorReporter.captureError(error, {
      context: 'ErrorBoundary',
      additionalData: { componentStack: info.componentStack },
    });
  };

  useEffect(()=>{
    // console.log("PWA installed? ",isPWA())
    isPWAVisits();
    // console.log("Consolevisit:", localStorage.getItem("firstVisit"))
    // if(isPWA() && localStorage.getItem("firstVisit")) {
    //   if(localStorage.getItem("currentURL")){
    //   console.log("URL:" + localStorage.getItem("currentURL"));
    //   window.alert("URL:" + localStorage.getItem("currentURL"));
    //   router.push(localStorage.getItem("currentURL"))}
    // }

    //serviceWorker registration
    // if ('serviceWorker' in navigator) {
    //   navigator.serviceWorker
    //     .register('./js/generate-sw.js')
    //     .then( registration => {
    //       console.log("Service worker registered", registration);
    //     })
    //     .catch (e => {
    //       console.log("Service worker registration failed", e);
    //     })
    // }
  },[])

  useEffect(() => {
    localStorage.setItem("currentURL", routerPath);
  }, [routerPath])
  

  useEffect(() => {
    if (isIOS) {
      document.documentElement.classList.add("ios-device");
    }
    if (routerPath && 
      routerPath != "/" &&
      routerPath != "/404" &&
      !routerPath.includes("account") &&
      !routerPath.includes("login") &&
      !routerPath.includes("register") &&
      !routerPath.includes("activate-account") &&
      !routerPath.includes("collection/") &&
      !routerPath.includes("/products/") &&
      !routerPath.includes("your-bag") &&
      !(typeof pages[0] != "undefined" && valinPLPs.includes(pages[0]))
    ) {
      viewOther();
    }
  }, []);
  
  // useEffect(() => {
  //   // To fix the welcome video loading issue
  //   const loadComponent = async () => {
  //     await new Promise((resolve) => setTimeout(resolve, 3000));
  //     setIsComponentLoaded(true);
  //   };
  //   loadComponent();
  // }, []);

  

  if (router.pathname.includes("/test-webpack")) {
    return (
      <>
        <Provider store={store}>
          {/* <Layout footerRef={footerRef}> */}
          <Component {...pageProps} key={router.asPath} footerRef={footerRef} />
          {/* </Layout> */}
        </Provider>
      </>
    );
  } else {
    return (
      <ErrorBoundary FallbackComponent={ErrorComp} onError={myErrorHandler}>
        <Head>
      {(process.env.APP_MODE != 'production')&&<meta name="robots" content="noindex, nofollow" />}
          {/* canonical links basically helps to  prevent parameters to appear on Google search results and also improves SEO */}
          <link rel="manifest" crossOrigin="use-credentials" href="/manifest.json" />
          {(router.asPath === "/" || router.asPath.includes("/editorial"))&&<link rel="canonical" href={canonicalUrl} />}
          <link rel="shortcut icon" href="/fav.png" />
          <link rel="apple-touch-icon" href="/fav.png" />
          <link rel="apple-touch-icon" sizes="72x72" href="/apple-touch-ipad-fav.png" />
          <link rel="apple-touch-icon" sizes="114x114" href="/apple-touch-iphone4-fav.png" />
          <link rel="apple-touch-icon" sizes="120x120" href="/apple-touch-icon-120x120.png" />
          <link rel="apple-touch-icon" sizes="120x120" href="/apple-touch-icon-120x120-precomposed.png" />
          <link rel="apple-touch-icon" sizes="144x144" href="/apple-touch-ipad-retina-fav.png" />
          <link rel="preload" href={`${process.env.NETLIFY_URL}/fonts/AktivGroteskExBasic-Regular.woff2`} as="font" type="font/woff2" />
          <link rel="preload" href={`${process.env.NETLIFY_URL}/fonts/AktivGroteskExBasic-Regular.woff`} as="font" type="font/woff" />
          <link rel="preload" href={`${process.env.NETLIFY_URL}/fonts/AktivGroteskExBasic-Medium.woff2`} as="font" type="font/woff2" />
          <link rel="preload" href={`${process.env.NETLIFY_URL}/fonts/AktivGroteskExBasic-Medium.woff`} as="font" type="font/woff" />

          <link rel="preload" as="image" href="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAQAICRAEAOw==" fetchpriority="high" />
          
        </Head>
        <Provider store={store}>
          {/* {!isComponentLoaded ?
            <WelcomeLoader appLoaded={appLoaded} setAppLoaded={setAppLoaded} /> :
         */}
            <Layout footerRef={footerRef}>
              <Component
                {...pageProps}
                key={router.pathname} s
                footerRef={footerRef}
              />
            </Layout>
            {/* } */}
        </Provider>
      </ErrorBoundary>  
    );
  }
}

if (typeof window !== 'undefined') {
  window.onerror = (message, source, lineno, colno, error) => {
    ErrorReporter.captureError(error || new Error(message), {
      context: 'GlobalError',
      additionalData: { source, lineno, colno }
    });
  };

  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    ErrorReporter.captureError(event.reason, {
      context: 'UnhandledRejection'
    });
  });
}

export default MyApp;
